<template>
  <v-card elevation="0">
    <v-card-title class="title">
      {{ $t('settings.user.otp.qrcode') }}
    </v-card-title>
    <v-card-subtitle>
      {{ $t('settings.user.otp.qrcHelp') }}
    </v-card-subtitle>
    <v-card-text align="center">
      <canvas ref="qrcode"></canvas>
    </v-card-text>
  </v-card>
</template>

<script>
import QRCode from 'qrcode'
export default {
  name: 'settings-user-otp-qrcode',
  props: {
    uri: {
      type: String
    }
  },
  mounted () {
    QRCode.toCanvas(this.$refs.qrcode, this.uri,
      { errorCorrectionLevel: 'H' }, (err) => {
        if (err) {
          this.dbg('Failed to generate canvas: %s', err)
        }
      })
  }
}
</script>

<style scoped>
</style>
